import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GooglePayButton from '@google-pay/button-react';

import {
    cardPaymentMethod,
    baseRequest,
    baseCardPaymentMethod
} from '../../../services/googlepay/constants';
import { GOOGLE_PAY } from '../../../constants/paymentMethods';
import { CHECKOUT_API_KEY, GOOGLE_PAY_MERCHANT_ID } from '../../../constants';

import { createOrder } from '../../../services/ebon/actions';
import { submitGooglePay } from '../../../services/googlepay/actions';

import { LoadingComponent } from '../../loading/LoadingComponent';

const GooglePayWrapper = ({
    userInfo,
    partnerId,
    cartTotalValue,
    i18n,
    BRAND_NAME,
    ebonPaymentConfig,
    paymentMethods,
    order,
    ebon,
    createOrder,
    submitGooglePay
}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [googlePayAvailable, setGooglePayAvailable] = useState(false);
    const [googleToken, setGoogleToken] = useState(null);
    const googlePayClientRef = useRef(null);

    const environment = CHECKOUT_API_KEY.includes('_sbox_') ? 'TEST' : 'PRODUCTION';

    const googlePayAllowed =
        ebonPaymentConfig.googlePayAllowed && paymentMethods.includes(GOOGLE_PAY);
    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    const paymentRequest = Object.assign(
        {
            allowedPaymentMethods: [cardPaymentMethod],
            merchantInfo: {
                merchantName: BRAND_NAME,
                merchantId: GOOGLE_PAY_MERCHANT_ID
            },
            transactionInfo: {
                totalPriceStatus: 'FINAL',
                totalPrice: cartTotalValue.toString(),
                currencyCode: 'EUR',
                countryCode: 'FR'
            }
        },
        baseRequest
    );

    /* [Start] Enable Google Pay */
    useEffect(() => {
        setLoading(true);
        enableGooglePay();
    }, []);

    const enableGooglePay = () => {
        if (window.google && googlePayAllowed) {
            const paymentsClient = new window.google.payments.api.PaymentsClient({
                environment: environment
            });
            const isReadyToPayRequest = Object.assign(
                { allowedPaymentMethods: [baseCardPaymentMethod] },
                baseRequest
            );
            paymentsClient
                .isReadyToPay(isReadyToPayRequest)
                .then(response => {
                    if (response.result) {
                        googlePayClientRef.current = paymentsClient;
                        setLoading(false);
                        setGooglePayAvailable(true);
                    }
                })
                .catch(function(err) {
                    setLoading(false);
                    setError(true);
                    console.error('error GP ready to pay : ', err);
                });
        }
    };
    /* [End] Enable Google Pay */

    /* [Start] Init Google Pay Button */
    const loadGooglePayData = async paymentData => {
        const token = await JSON.parse(paymentData.paymentMethodData.tokenizationData.token);
        setGoogleToken(token);

        createOrder(partnerId, userInfo.phoneNumber, null, !hasFreeFacial);
    };
    /* [End] Init Google Pay Button */

    /* [Start] Submit payment */
    useEffect(() => {
        if (googleToken && googlePayAvailable && order && order.orderState === 'created') {
            processGooglePayPayment();
        }
    }, [googleToken, googlePayAvailable, order]);

    const processGooglePayPayment = () => {
        if (window.google && googlePayClientRef.current) {
            submitGooglePay(googleToken, userInfo, partnerId, order.id);
        }
    };
    /* [End] Submit payment */

    return (
        <React.Fragment>
            {googlePayAvailable && (
                <GooglePayButton
                    environment={environment}
                    buttonColor="black"
                    buttonType="checkout"
                    buttonRadius={5}
                    buttonLocale="fr"
                    buttonSizeMode="fill"
                    style={{ width: '100%', height: 45, marginTop: 10 }}
                    paymentRequest={paymentRequest}
                    onLoadPaymentData={loadGooglePayData}
                />
            )}

            {loading && <LoadingComponent />}

            {error && <p className="error">{i18n.PAYMENT_CHOICE.ERROR_MESSAGE}</p>}
        </React.Fragment>
    );
};

GooglePayWrapper.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    cartTotalValue: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        BRAND_NAME: state.i18n.common.BRAND_NAME,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig,
        paymentMethods: state.ebon.lock[0].paymentMethods || [],
        order: state.ebon.createdOrder,
        ebon: state.ebon
    };
};

const mapDispatchToProps = {
    createOrder,
    submitGooglePay
};

export default connect(mapStateToProps, mapDispatchToProps)(GooglePayWrapper);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/GooglePayButton.js